import {
  CATEGORIES_LOADING,
  CATEGORIES_ERROR,
  CATEGORIES_LOADED,
} from "../constants/actionTypes";

const defaultState = {
  data: [],
  excludedIds: [],
  loading: true,
  error: false,
};

export default function categories(state = defaultState, action) {
  switch (action.type) {
    case CATEGORIES_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        data: [],
        excludedIds: [],
      };
    case CATEGORIES_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
        data: [],
        excludedIds: [],
      };
    case CATEGORIES_LOADED:
      return {
        ...state,
        error: false,
        loading: false,
        data: action.payload.filteredData,
        excludedIds: action.payload.excludedIds,
      };
    default:
      return state;
  }
}
